<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">系统设置</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">分配管理</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="data-list">
            <a-divider orientation="left">
            线索分配方式
            </a-divider>

            <div class="fpstyle" >
                <a-radio-group v-model="detail.distribution_type" size="large" @change="onChange" >
                    <a-radio :value="1" >
                    自动分配
                    </a-radio>

                    <p>分配方式：将所有未被分配的线索和每次导入的新线索平均分配给所有员工， 然后将剩余的线索分配给第一位员工。设置后根据所选基础规则自动分配所有线索</p>

                    <a-radio :value="2" style="margin-top:30px">
                    手动分配
                    </a-radio>

                    <p>分配方式：使用手工分配无需设置规则，完全以手工分配为准，由管理员手动将线索分配给员工</p>
                </a-radio-group>

                <a-button type="primary" @click="tofptype" style="margin-top:20px">
                    确定
                </a-button>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            type:"",
            detail:""
        }
    },
    mounted(){
        this.getdetail()
    },
    methods:{
        onChange(e) {
            this.type=e.target.value
        },
        tofptype(){
            this.$axios.post('/api/system/systemset',{
                distribution_type:this.type
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
                
            })
        },

        getdetail(){
            this.$axios.post('/api/system/systemsetpage',{

            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.detail=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
                
            })
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/components/system/allocation.vue